export const manage_modal = (state = false, action) => {
	switch (action.type) {
		case 'CLOSE_LOGIN_MODAL':
	  		return false;
  		case 'OPEN_LOGIN_MODAL':
	  		return true;
		default:
	  		return state;
	}
};